import { BehaviorSubject } from "rxjs";
import CookieStorage from "../../../utils/CookieStorage";
import { CASE_FILTER_STATE } from "../types/CommonTypes";
import { startOfDay, subDays } from "date-fns";

export const initialCaseFilterState: CASE_FILTER_STATE = {
  dateRange: {
    from: startOfDay(subDays(new Date(), 6)),
    to: startOfDay(new Date()),
  },
  patientName: "",
  mrn: [],
  caseIds: [],
  ots: [],
  procedureIds: [],
  attendingSurgeonNames: [],
  submittedBy: [],
  autoClosed: null,
  inconsistentTimestamps: null,
};

const caseFilterState$ = new BehaviorSubject<CASE_FILTER_STATE>(
  initialCaseFilterState
);
CookieStorage.init("caseFilterState", caseFilterState$);

const caseFilterCount$ = new BehaviorSubject<number>(0);
CookieStorage.init("caseFilterCount", caseFilterCount$);

export default caseFilterState$;
export { caseFilterCount$ };
